// Duplicate naming: "<base> (n)", where n is one above the highest number any sibling
// currently carries for that base. Deleted siblings drop out of the pool, so a number can
// come back after a permanent delete; it is never reused while its holder still exists.
// Names from the old " Copy" scheme are left as they are: they simply become a base.

export const getDuplicateNameBase = (name: string): string => name.replace(/ \([1-9]\d*\)$/, '');

// Regex source (usable as a Mango `$regex`) matching every numbered duplicate of `base`.
export const duplicateNameRegexSource = (base: string): string => `^${escapeRegex(base)} \\([1-9]\\d*\\)$`;

export const nextDuplicateName = (base: string, siblingNames: string[]): string => {
  const highest = siblingNames.reduce((max, name) => {
    const match = / \(([1-9]\d*)\)$/.exec(name);
    return match && name.slice(0, -match[0].length) === base ? Math.max(max, Number(match[1])) : max;
  }, 0);

  return `${base} (${highest + 1})`;
};

const escapeRegex = (value: string) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
